import { Route, Routes, useSearchParams, useLocation } from "react-router";
import styled from "styled-components";
import media from "styled-media-query";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../redux";
import { bindActionCreators } from "redux";
import { Product, ProductScheme, Volunteer } from "client-v2";

import Checkout from "../views/shop/Checkout";

import { Feedback } from "@adoptaunabuelo/react-components";
import { useEffect, useState } from "react";
import Loading from "../components/modal/Loading";

const FeedbackStyled = styled(Feedback)`
	right: 24px !important;
	left: unset !important;
	${media.lessThan("small")`
        top: 64px;
        left: 24px !important;
        bottom: unset !important;
	`}
`;

const ShopLayout = (props: ShopLayoutProps) => {
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const error = useSelector((state: State) => state.modals.error);
	const currentUser = useSelector((state: State) => state.user.currentUser);
	const location = useLocation();

	const [searchParams, setSearchParams] = useSearchParams();
	const [product, setProduct] = useState<ProductScheme | undefined>(
		undefined
	);
	const [isSubscriptor, setIsSubscriptor] = useState(false);
	const [view, setView] = useState("shop");

	useEffect(() => {
		getProduct();
	}, []);

	const getProduct = async () => {
		const id = searchParams.get("id");
		const stateProduct =
			location.state && location.state.product
				? location.state.product
				: undefined;
		const view =
			location.state && location.state.view
				? location.state.view
				: undefined;
		setView(view ? view : "shop");
		if (stateProduct) {
			const isSubscriptor = currentUser
				? await Volunteer.isSubscriptor(currentUser.objectId)
				: { data: false };
			setIsSubscriptor(isSubscriptor.data);
			setProduct(stateProduct);
		} else if (id) {
			Product.getById(id)
				.then(async (result) => {
					if (result.data.type === "shop") {
						const isSubscriptor = currentUser
							? await Volunteer.isSubscriptor(
									currentUser.objectId
							  )
							: { data: false };
						setIsSubscriptor(isSubscriptor.data);
						setProduct(result.data);
					} else {
						setShowError({
							show: true,
							message: "El producto no es válido",
						});
					}
				})
				.catch((error) => {
					setShowError({
						show: true,
						message: "El parámetro id no es válido",
					});
				});
		} else {
			setShowError({
				show: true,
				message: "El parámetro id no es válido",
			});
		}
	};

	return (
		<>
			<FeedbackStyled
				isVisible={error.show}
				type="error"
				text={error.message}
				onClose={() => setShowError({ show: false })}
			/>
			<Routes>
				<Route
					path="/"
					element={
						!product ? (
							<Loading isVisible={true} />
						) : (
							<Checkout
								product={product}
								isSubscriptor={isSubscriptor}
								view={view}
							/>
						)
					}
				/>
			</Routes>
		</>
	);
};

export default ShopLayout;
export interface ShopLayoutProps {}
